import React, { useEffect, useState, useRef } from "react";
import { FigureCard, CardHeader } from "@adeccoux/tag-ds";

const DisplayType4 = ({
    test,
    setnextDisable,
    setSelectedAns1,
    setSelectedAns2,
    setSelectedAns3,
    setSelectedAns4,
    selectedC,
    selectedAns1,
    selectedAns2,
    selectedAns3,
    selectedAns4,
}) => {
    const [refresh, setRefresh] = useState(true);
    const chunk1 = test.questions[0].answers;
    const chunk2 = test.questions[1].answers;
    const chunk3 = test.questions[2].answers;
    const chunk4 = test.questions[3].answers;

    const setSel = selectedC;
    const selectedC1 = useRef(-1);
    const selectedC2 = useRef(-1);
    const selectedC3 = useRef(-1);
    const selectedC4 = useRef(-1);

    useEffect(() => {
        if (
            selectedAns1 === -1 &&
            selectedAns2 === -1 &&
            selectedAns3 === -1 &&
            selectedAns4 === -1
        )
            setnextDisable(true);
        setRefresh((prev) => !prev);
    }, [selectedC]);

    useEffect(() => {
        selectedC1.current = selectedAns1;
        selectedC2.current = selectedAns2;
        selectedC3.current = selectedAns3;
        selectedC4.current = selectedAns4;
    }, []);

    const handlenextNavigateDis = () => {
        if (
            selectedC1.current > -1 &&
            selectedC2.current > -1 &&
            selectedC3.current > -1 &&
            selectedC4.current > -1
        ) {
            setnextDisable(false);
        }
    };

    const handleChunks1 = (e) => {
        selectedC1.current = e;
        setSelectedAns1(e);
        handlenextNavigateDis();
    };

    const handleChunks2 = (e) => {
        selectedC2.current = e;
        setSelectedAns2(e);
        handlenextNavigateDis();
    };

    const handleChunks3 = (e) => {
        selectedC3.current = e;
        setSelectedAns3(e);

        handlenextNavigateDis();
    };

    const handleChunks4 = (e) => {
        selectedC4.current = e;
        setSelectedAns4(e);
        handlenextNavigateDis();
    };

    return (
        <React.Fragment key={refresh}>
            <div className="flex_row g2">
                {chunk1.map((val, ind) => (
                    <FigureCard
                        key={ind}
                        onClick={() => handleChunks1(val.position)}
                        selected={val.position == selectedAns1}
                    >
                        <CardHeader id="figure card header">
                            <h4
                                dangerouslySetInnerHTML={{
                                    __html: val.content,
                                }}
                            />
                        </CardHeader>
                    </FigureCard>
                ))}
            </div>
            <div className="flex_row g2">
                {chunk2.map((val, ind) => (
                    <FigureCard
                        key={ind}
                        onClick={() => handleChunks2(val.position)}
                        selected={val.position == selectedAns2}
                    >
                        <CardHeader id="figure card header">
                            <h4
                                dangerouslySetInnerHTML={{
                                    __html: val.content,
                                }}
                            />
                        </CardHeader>
                    </FigureCard>
                ))}
            </div>
            <div className="flex_row g2">
                {chunk3.map((val, ind) => (
                    <FigureCard
                        key={ind}
                        onClick={() => handleChunks3(val.position)}
                        selected={val.position == selectedAns3}
                    >
                        <CardHeader id="figure card header">
                            <h4
                                dangerouslySetInnerHTML={{
                                    __html: val.content,
                                }}
                            />
                        </CardHeader>
                    </FigureCard>
                ))}
            </div>
            <div className="flex_row g2">
                {chunk4.map((val, ind) => (
                    <FigureCard
                        key={ind}
                        onClick={() => handleChunks4(val.position)}
                        selected={val.position == selectedAns4}
                    >
                        <CardHeader id="figure card header">
                            <h4
                                dangerouslySetInnerHTML={{
                                    __html: val.content,
                                }}
                            />
                        </CardHeader>
                    </FigureCard>
                ))}
            </div>
        </React.Fragment>
    );
};

export default DisplayType4;
